<template>
  <div>
    <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home/Home' }">报表</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">工资报表</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

       <!-- 搜索筛选 -->
       <el-form :model="form" class="user-search" label-width="120px" size="small">

        <el-row>
          <el-col :span="6" v-if="'account' in colObj2">
            <el-form-item label="账号" >
              <el-input size="small" v-model="form.account" placeholder="账号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'name' in colObj2">
            <el-form-item label="生产人员" >
              <!-- <el-input size="small" v-model="form.name" placeholder="生产人员" clearable></el-input> -->
              <el-select
                  v-model="form.name"
                  clearable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in workAuthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.show"
                  ></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'createTime' in colObj2">
            <el-form-item label="实际报工时间">
                <el-date-picker
                  key="0"
                  style="width: 100%;"
                  v-model="form.createTime"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'unApproveGoodNum' in colObj2">
            <el-form-item label="未审批报工数">
              <el-input-number
              size="small"
              v-model="form.unApproveGoodNum"
              placeholder="未审批报工数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          </el-row>
          <el-row>
          <el-col :span="6" v-if="'unApproveSalaryCountByNum' in colObj2">
            <el-form-item label="未审批计件工资">
              <el-input-number
              size="small"
              v-model="form.unApproveSalaryCountByNum"
              placeholder="未审批计件工资"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'unApproveSalaryCountByTime' in colObj2">
            <el-form-item label="未审批计时工资">
              <el-input-number
              size="small"
              v-model="form.unApproveSalaryCountByTime"
              placeholder="未审批计时工资"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'approveGoodNum' in colObj2">
            <el-form-item label="已审批报工数">
              <el-input-number
              size="small"
              v-model="form.approveGoodNum"
              placeholder="已审批报工数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'approveSalaryCountByNum' in colObj2">
            <el-form-item label="已审批计件工资">
              <el-input-number
              size="small"
              v-model="form.approveSalaryCountByNum"
              placeholder="已审批计件工资"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          </el-row>
          <el-row>
          <el-col :span="6" v-if="'approveSalaryCountByTime' in colObj2">
            <el-form-item label="已审批计时工资">
              <el-input-number
              size="small"
              v-model="form.approveSalaryCountByTime"
              placeholder="已审批计时工资"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'totalGoodNum' in colObj2">
            <el-form-item label="报工总数">
              <el-input-number
              size="small"
              v-model="form.totalGoodNum"
              placeholder="报工总数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>


          <el-col :span="4" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="getdata">查询</el-button>
            <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow2"
              >
              <PopoverContentNew :colData="colData2" @done="popDone2" v-if="popIshow2" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">关键词配置</el-button>
            </el-popover>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-popover
              placement="left-start"
              title="关键词配置"
              width="200"
              trigger="click"
              v-model="popIshow"
              >
              <PopoverContentNew :colData="colData" @done="popDone" v-if="popIshow" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">关键词配置</el-button>
            </el-popover>
          </el-col>
        </el-row>
        <el-table
        ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
        >
          <el-table-column align="left" type="selection" :reserve-selection="true" width="60"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="account" label="账号" v-if="'account' in colObj"></el-table-column>
          <el-table-column prop="name" label="生产人员" v-if="'name' in colObj"></el-table-column>

          <el-table-column prop="unApproveGoodNum" label="未审批报工数" v-if="'unApproveGoodNum' in colObj"></el-table-column>
          <el-table-column prop="unApproveSalaryCountByNum" label="未审批计件工资" v-if="'unApproveSalaryCountByNum' in colObj"></el-table-column>
          <el-table-column prop="unApproveSalaryCountByTime" label="未审批计时工资" v-if="'unApproveSalaryCountByTime' in colObj"></el-table-column>
          <el-table-column prop="approveGoodNum" label="已审批报工数" v-if="'approveGoodNum' in colObj"></el-table-column>
          <el-table-column prop="approveSalaryCountByNum" label="已审批计件工资" v-if="'approveSalaryCountByNum' in colObj"></el-table-column>
          <el-table-column prop="approveSalaryCountByTime" label="已审批计时工资" v-if="'approveSalaryCountByTime' in colObj"></el-table-column>
          <el-table-column prop="totalGoodNum" label="报工总数" v-if="'totalGoodNum' in colObj"></el-table-column>
          <el-table-column prop="totalSalary" label="工资小计" v-if="'totalSalary' in colObj"></el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      </div>

  </div>
</template>
<script>

import {salaryReport,queryAllUserList} from '@/api/business';
import Pagination from "@/components/Pagination";
import moment from 'moment';
import PopoverContentNew from '@/components/PopoverContentNew'
import {exportDataToExcel,transfer} from '@/utils/util';


export default {
  name: "StaffWork",
  components:{
      Pagination,
      PopoverContentNew
  },
  data() {
    return {
      form: {},
      orderStatusList: [
        {
          label: "自制",
          value: "0"
        },
        {
          label: "外购",
          value: "1"
        },
        {
          label: "委外",
          value: "2"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      createProductPanVisible:false,
      isMain:true,
      userData:{},
      editRow:{},
      mode:'',
      sourceList:[{
        label:'自制',
        value:'0'
      },{
        label:'外购',
        value:'1'
      },{
        label:'委外',
        value:'2'
      }],
      setList:[],
      popIshow:false,//控制popover显隐
      colData:[],
      colDataRes:{
        "账号":"account",
        "生产人员":"name",
        "未审批报工数":"unApproveGoodNum",
        "未审批计件工资":"unApproveSalaryCountByNum",
        "未审批计时工资":"unApproveSalaryCountByTime",
        "已审批报工数":"approveGoodNum",
        "已审批计件工资":"approveSalaryCountByNum",
        "已审批计时工资":"approveSalaryCountByTime",
        "报工总数":"totalGoodNum",
        "工资小计":"totalSalary",
        "实际报工时间":"createTime"
      },
      colObj:{},
      popIshow2:false,
      colData2:[],
      colObj2:{},
      tblSelectionList:[],
      workAuthList: [],
    };
  },
  created() {
    for(let key in this.colDataRes){
      if(key != "实际报工时间"){

        this.colData.push({label:this.colDataRes[key],value:key,istrue:true});
        this.colObj[this.colDataRes[key]] = key;
      }
      if(key != "工资小计"){

        this.colData2.push({label:this.colDataRes[key],value:key,istrue:true});
        this.colObj2[this.colDataRes[key]] = key;
      }
    }
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
      this.init();
      this.initDict();


    }
  },
  methods: {
    async initDict(){
      var res = await queryAllUserList(this.userData.factoryId);
      if(res['code'] == 200){
        this.workAuthList = res.data.map(function(item){
          return {
            label:item.name + '(' + item.account + ')',
            show:item.name,
            value:item._id,
          }
        });
      }
    },
    //导出数据前对数据处理，变为想要的格式。
    filterTableData(data) {
      data.forEach((item) => {
       item.goodRate = item.goodRate?item.goodRate.toFixed(2):""
      });
      return data;
    },
    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportExcel();
        return;
      }
      const header = [
        '账号',
        '生产人员',
        '未审批报工数',
        '未审批计件工资',
        '未审批计时工资',

        '已审批报工数',
        '已审批计件工资',
        '已审批计时工资',
        '报工总数',
        '工资小计',

      ];

      const filterVal = [
        'account',
        'name',
        'unApproveGoodNum',
        'unApproveSalaryCountByNum',
        'unApproveSalaryCountByTime',
        'approveGoodNum',
        'approveSalaryCountByNum',
        'approveSalaryCountByTime',
        'totalGoodNum',
        'totalSalary',
      ];
      let filterData =JSON.parse(JSON.stringify(this.tblSelectionList));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"工资报表统计"+ Date.now());
    },
    popDone:function(options){
      var _this = this
      this.popIshow = false
      if(options.type == 'save'){
        this.colData = JSON.parse(JSON.stringify(options.data));
        this.colObj = {};
        for(let i = 0;i<this.colData.length;i++){
          if(this.colData[i].istrue){
            this.colObj[this.colData[i].label] = this.colObj[this.colData[i].value];
          }
        }
        this.init();
      }
    },
    popDone2:function(options){
      var _this = this
      this.popIshow2 = false
      if(options.type == 'save'){
        this.colData2 = JSON.parse(JSON.stringify(options.data));
        this.colObj2 = {};
        var _form = {};
        for(let i = 0;i<this.colData2.length;i++){
          if(this.colData2[i].istrue){
            this.colObj2[this.colData[i].label] = this.colObj2[this.colData2[i].value];
            _form[this.colData[i].label] = this.form[this.colData[i].label]
          }
        }
        this.form = JSON.parse(JSON.stringify(_form));
        this.init();
      }
    },
    init(){
      this.search();
    },
    fold() {
      this.isFold = !this.isFold;
    },
    getdata(){
      this.pageparm.currentPage = 1;
      this.pageparm.pageSize = 10;
      this.search();
    },
    search() {
      this.loading = true
      var data = {
        condition: {},
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      for(var key in this.form){

        if(this.form[key] && this.form[key] != null && (this.form[key].length > 0 || this.form[key].toString() != '')){
            if(key == "createTime"){
              data['condition'][key] = {
                begin:this.form.createTime[0].substring(0,10) + " 00:00:00",
                end:this.form.createTime[1].substring(0,10) + " 23:59:59",
                type:"between" ,
                data:'date'
              }
            }else{

              data['condition'][key] = this.form[key];
            }
        }
      }
      data.condition.factoryId=this.userData.factoryId;
      salaryReport(data).then(res => {
        if(res.code == 200){
          this.pageparm = res.data;
          this.listData = res.data.list
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },
     // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.search();
    },
    exportExcel(){
      var data = {
        condition: {},
        type:"工资报表",
        currentPage: 1,
        pageSize: 10000,
      }
      for(var key in this.form){

        if(this.form[key] && this.form[key] != null && (this.form[key].length > 0 || this.form[key].toString() != '')){
            if(key == "createTime"){
              data['condition'][key] = {
                begin:this.form.createTime[0].substring(0,10) + " 00:00:00",
                end:this.form.createTime[1].substring(0,10) + " 23:59:59",
                type:"between" ,
                data:'date'
              }
            }else{

              data['condition'][key] = this.form[key];
            }
        }
      }
      data.condition.factoryId=this.userData.factoryId;
      // var data = {
      //   condition: this.form,
      //   type:"工资报表",
      //   currentPage: 1,
      //   pageSize: 10000,
      // }
      // data.condition.factoryId=this.userData.factoryId;
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/report/export';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "工资报表" + moment().format("YYYYMMDDHHmmss") + ".xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(data));
    },
    productSave(options){
        if(options.type == 'save'){
          this.search()
        }
        this.createProductPanVisible =false;

    },
    viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    productFormat(val){
      var res = this.sourceList.filter(function(item){
        return item.value == val.source
      })
      if(res && res.length!=0){
        return res[0].label
      }
    },
  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/home/report/StaffWork.vue